import { render, staticRenderFns } from "./data-item.vue?vue&type=template&id=3502ba77&scoped=true"
import script from "./data-item.vue?vue&type=script&lang=js"
export * from "./data-item.vue?vue&type=script&lang=js"
import style0 from "./data-item.vue?vue&type=style&index=0&id=3502ba77&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502ba77",
  null
  
)

export default component.exports